import { render, staticRenderFns } from "./RuleArchivePayload.vue?vue&type=template&id=08bb71cc&scoped=true"
import script from "./RuleArchivePayload.vue?vue&type=script&lang=ts"
export * from "./RuleArchivePayload.vue?vue&type=script&lang=ts"
import style0 from "./RuleArchivePayload.vue?vue&type=style&index=0&id=08bb71cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bb71cc",
  null
  
)

export default component.exports